<button
  class="custom-button"
  [title]="'services.snackbar.notification' | translate"
  (click)="toggleNotifications()"
  (blur)="notificationsClosed()"
  style="z-index:100;"
  >
  <img alt="" src="assets/icons/notifications.svg" width="24" height="24" />
  @if (unseenNotifications.length > 0) {
    <span class="custom-badge">
      {{ unseenNotifications.length }}
    </span>
  }
</button>
<div class="notification-container">
  @if (notificationsOpened) {
    <app-notification-popup [notifications]="notifications"></app-notification-popup>
  }
</div>
